import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./FilterBadge.css";

const BADGE_COLORS = {
  Doença: "#0A91FF",         
  Medicamento: "#F7931E",    
  Procedimento: "#9B55CA",  
  Data: "#6C757D",           
};

function FilterBadge({ label, category, onRemove }) {
  return (
    <div className="filter-badge" style={{ backgroundColor: BADGE_COLORS[category] }}>
      <span>{label}</span>
      <CloseIcon className="close-icon" onClick={onRemove} />
    </div>
  );
}

export default FilterBadge;
